import { useMemo } from 'react'
import { useQuery, gql } from '@apollo/client'

import { useSites } from 'store'

const OPERATION_FIND_MESSAGE = gql`
  query FindMessage($sf_id: String!) {
    message: findMessage(sf_id: $sf_id) {
      id
      title
      content
      site_sf_id
      enable
    }
  }
`

const useMessages = () => {
  const [{ selected }] = useSites()

  const sfIds = useMemo(
    () => selected ? selected.map(({ sf_id }) => sf_id).join(',') : '',
    [selected],
  )
  const { data, loading } = useQuery(OPERATION_FIND_MESSAGE, {
    variables: {
      sf_id: sfIds,
    }
  })

  return {
    messages: data?.message ? [data.message] : [],
    loading,
  }
}

export default useMessages